var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4294 3.46538L7.80565 0.10922L7.8029 0.107844C7.50797 -0.0389924 7.15752 -0.0357112 6.86534 0.116633L4.02445 1.62437C4.00137 1.63415 3.97919 1.64602 3.95795 1.65967L0.553594 3.46647C0.212109 3.64527 0 3.9956 0 4.38117V10.6179C0 11.0035 0.212109 11.3538 0.553594 11.5326L6.86253 14.881L6.86537 14.8825C7.01437 14.9602 7.17858 14.9991 7.34282 14.9991C7.50059 14.9991 7.65841 14.9632 7.8029 14.8913L14.4294 11.5337C14.7814 11.3577 15 11.004 15 10.6103V4.38882C15 3.9951 14.7814 3.6414 14.4294 3.46538ZM7.27257 0.895138C7.31561 0.873049 7.36699 0.872609 7.41041 0.893908L13.6105 4.03541L11.1975 5.23673L5.13598 2.0291L7.27257 0.895138ZM6.89719 13.9047L0.96416 10.7558L0.961318 10.7543C0.910312 10.7277 0.878584 10.6755 0.878584 10.6179V4.77762L6.89719 7.91602V13.9047ZM7.34112 7.15664L1.35563 4.0355L4.19813 2.52692L10.2296 5.71861L7.34112 7.15664ZM14.1214 10.6102C14.1214 10.669 14.0887 10.7218 14.0361 10.748L7.7758 13.92V7.92167L10.6582 6.48665V7.99119C10.6582 8.2338 10.8549 8.4305 11.0975 8.4305C11.3401 8.4305 11.5368 8.2338 11.5368 7.99119V6.04922L14.1214 4.7625V10.6102Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.fa5fa21b4317d815afe43487e8141204.svg";
export { ForwardRef as ReactComponent };